import { ROOT_GLOBAL } from "../global/root";

export class SiteCategory {
  constructor(
    id,
    name,
    type,
    slug,
    siteBackground,
    isActive,
  ) {
    this.id = id;
    this.name = name;
    this.type = type;
    this.slug = slug;
    this.siteBackground = siteBackground;
    this.isActive = isActive;
  }

  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      return new SiteCategory(
        input.id,
        input.name,
        input.category_type,
        input.slug,
        input.site_background,
        input.is_active,
      )
    }

    return new SiteCategory();
  }

  static fromApiArray(input) {
    if (input && Array.isArray(input)) {
      return input.map(item => SiteCategory.fromApiObject(item));
    }

    if (input && typeof (input) === "object") {
      return [SiteCategory.fromApiObject(input)];
    }

    return [];
  }

  static isSkipCategory(category) {
    if (!category) return true;
    return category === SiteCategory.ALL_CATEGORY.value || category === SiteCategory.POPULAR_CATEGORY.value || category === SiteCategory.SALE_CATEGORY.value;
  }

  static isPopularCategory(category) {
    return category === SiteCategory.POPULAR_CATEGORY.value;
  }

  static isAllCategory(category) {
    return category === SiteCategory.ALL_CATEGORY.value;
  }

  static isSalesCategory(category) {
    return category === SiteCategory.SALE_CATEGORY.value;
  }

  static getRedirectUrl(categoryId) {
    let listExcept = [SiteCategory.NEW_CATEGORY.value, SiteCategory.ALL_CATEGORY.value];
    return categoryId && !listExcept.includes(categoryId) ? ROOT_GLOBAL.AVAILABLE_STORES + "?fca=" + categoryId : ROOT_GLOBAL.AVAILABLE_STORES;
  }

  static genParamsBstSale(category) {
    let params = { "soas": {}, "bst": [] };

    if (category === SiteCategory.POPULAR_CATEGORY.value) {
      params["bst"].push({
        "v": { "string_filter.val": ["logo_1"] },
        "b": 1
      });
    } else {
      params["bst"].push({
        "v": {
          "number_filter.sale_expires_at_gte": Math.round(Date.now() / 1000)
        },
        "b": 100
      });
    }

    if ([SiteCategory.SALE_CATEGORY.value, SiteCategory.POPULAR_CATEGORY.value].includes(category)) {
      params["soas"] = {
        "number_sort.product_count": "desc"
      }
    } else {
      params["soas"] = {
        "number_sort.updated_at": "desc"
      }
    }

    return params;
  }

  static ALL_CATEGORY = { "value": "all", label: "sites_allStores" };
  static NEW_CATEGORY = { "value": "new", label: "sites_newCategory" };
  static POPULAR_CATEGORY = { "value": "popular", label: "sites_popularStores" };
  static SALE_CATEGORY = { "value": "sale", label: "sites_saleCategory" };
}